<template>
  <div class="container">
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
      <el-form class="mwow-wrap form" size="mini" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="班级名称:" prop="class_id">
              <el-select
                v-model="searchInfo.class_id"
                placeholder="请输入班级名称"
                clearable
                @focus="getSelectClassListFn('')"
                filterable
                :filter-method="getSelectClassListFn"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in classList"
                  :key="item.class_id"
                  :label="item.name"
                  :value="item.class_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课时间:" prop="lesson_date">
              <!-- <el-date-picker
                v-model="searchInfo.lesson_date"
                type="daterange"
                start-placeholder="开始时间"
                range-separator="至"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.lesson_date"
                start-placeholder="开始时间"
                range-separator="至"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="点评完成时间:"
              prop="comment_time"
              label-width="94px"
            >
              <!-- <el-date-picker
                v-model="searchInfo.comment_time"
                type="daterange"
                start-placeholder="开始时间"
                range-separator="至"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.comment_time"
                start-placeholder="开始时间"
                range-separator="至"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="点评教师:" prop="staff_id">
              <el-select
                v-model="searchInfo.staff_id"
                placeholder="请选择点评教师"
                clearable
                filterable
                :filter-method="getStaffList"
                @focus="getStaffList('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in staffList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科目:" prop="subject_id">
              <el-select
                v-model="searchInfo.subject_id"
                placeholder="请选择科目"
                clearable
                filterable
                :filter-method="getSeleSubjectsListFn"
                @focus="getSeleSubjectsListFn('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in subjectList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      :data="tableData"
      stripe
      ref="tableRef"
      style="width: 100%"
      tooltip-effect="dark"
      class="table"
      :default-sort="{ prop: 'create_time', order: 'descending' }"
      @sort-change="clickStort"
    >
      <el-table-column label="序号" type="index" min-width="70">
      </el-table-column>
      <el-table-column label="学员名称" prop="student.name"> </el-table-column>
      <el-table-column label="学员手机号" prop="student.mobile" min-width="110">
      </el-table-column>
      <el-table-column label="班级名称" prop="class.name" width="200">
      </el-table-column>
      <el-table-column
        label="上课时间"
        prop="lesson_full_start_time"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.date + " " + scope.row.start_time.slice(0, 5) }}
        </template>
      </el-table-column>
      <el-table-column
        label="点评完成时间"
        prop="comment_time"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        min-width="120"
      >
      </el-table-column>
      <el-table-column label="上课教室" prop="classroom_name" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.classroom_name ? scope.row.classroom_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="科目" prop="subject_name"> </el-table-column>
      <el-table-column label="点评教师" prop="staff_name"> </el-table-column>
      <el-table-column label="综合评价" prop="lesson_star" width="200">
        <template slot-scope="scope">
          <div style="display: flex">
            <el-rate v-model="scope.row.lesson_star.E" disabled></el-rate>
            <span style="color: rgba(7, 209, 170, 1)">
              {{ scope.row.lesson_star.E }}星
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="opreation" min-width="100">
        <template slot-scope="scope">
          <el-button class="mwow-button success" @click="toComment(scope)">
            查看点评
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { dateFormat } from "@/utils/timeFormat";
import {
  staffList,
  getSeleSubjectsList,
  getSelectClassList,
} from "@/api/globalSearch";
import { commentStudentListApi } from "@/api/classroomComment";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";

export default {
  props: ["visible"],
  components: {
    commonDateRangeSelector,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        class_id: "",
        lesson_date: [],
        comment_time: [],
        staff_id: "",
        subject_id: "",
        sort_field: "",
        sort_type: "",
      },
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tableData: [],
      classList: [],
      staffList: [],
      subjectList: [],
      effectiveDate: {
        disabledDate(date) {
          return date > Date.now();
        },
      },
    };
  },
  created() {
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page);
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleReset() {
      this.searchInfo = {
        class_id: "",
        lesson_date: [],
        comment_time: [],
        staff_id: "",
        subject_id: "",
        sort_field: "",
        sort_type: "",
      };
      this.handleSearch();
    },
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.searchInfo.class_id) {
        params.class_id = this.searchInfo.class_id;
      }
      if (
        this.searchInfo.lesson_date &&
        this.searchInfo.lesson_date.length === 2
      ) {
        params.attend_class_start_time =
          new Date(this.searchInfo.lesson_date[0] + " 00:00:01").getTime() /
          1000;
        params.attend_class_end_time =
          new Date(this.searchInfo.lesson_date[1] + " 23:59:59").getTime() /
          1000;
      }
      if (
        this.searchInfo.comment_time &&
        this.searchInfo.comment_time.length === 2
      ) {
        params.comment_start_time =
          new Date(this.searchInfo.comment_time[0] + " 00:00:01").getTime() /
          1000;
        params.comment_end_time =
          new Date(this.searchInfo.comment_time[1] + " 23:59:59").getTime() /
          1000;
      }
      if (this.searchInfo.subject_id) {
        params.subject_id = this.searchInfo.subject_id;
      }
      if (this.searchInfo.staff_id) {
        params.staff_id = this.searchInfo.staff_id;
      }
      if (this.searchInfo.sort_field) {
        params.sort_field = this.searchInfo.sort_field;
      }
      if (this.searchInfo.sort_type) {
        params.sort_type = this.searchInfo.sort_type;
      }
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      commentStudentListApi(option).then((res) => {
        if (res.error_code === 0) {
          // console.log("学员点评明细", res);
          res.data.list.forEach((item) => {
            item.comment_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(item.comment_time).getTime() * 1000
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    getSelectClassListFn(v) {
      getSelectClassList({
        page: 1,
        page_size: 100,
        name: v,
        select_type: 1,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classList = res.data.list;
        }
      });
    },
    getStaffList(v) {
      staffList({
        page: 1,
        page_size: 100,
        status: 1,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.staffList = res.data.list;
        }
      });
    },
    getSeleSubjectsListFn(v) {
      getSeleSubjectsList({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectList = res.data.list;
        }
      });
    },
    // 跳转
    toComment(scope) {
      this.$router.push({
        name: "comment",
        query: {
          comment_student_id: scope.row.comment_student_id,
          comment_id: scope.row.comment_id,
          student_id: scope.row.student.student_id,
          name: scope.row.student.name,
          from: "commentInfo",
          page: String(this.page),
          status: "catComment",
        },
      });
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.prop === "lesson_full_start_time") {
        this.searchInfo.sort_field = "lesson_full_start_time";
      }
      if (e.prop === "comment_time") {
        this.searchInfo.sort_field = "comment_time";
      }
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 70px 12px;
  border-radius: 4px;
}
</style>
